import { FloatingBackButton } from "@components/atoms/FloatingBackButton"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { ChipList } from "@components/layout/ChipList"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { EventRegistrationInfo } from "@features/events/components/EventRegistrationInfo"
import { getDateRange } from "@utils/dates"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { Fragment, useMemo } from "react"

export default defineView("single-event", (props) => {
  const dateRange = useMemo(() => {
    if (!props.event?.dates.length) return null
    return getDateRange(props.event?.dates.flatMap((d) => [d.startDate, d.endDate]).filter((d): d is string => !!d) ?? [])
  }, [props.event?.dates])

  return (
    <div>
      <StaggerTransitionRoot>
        <div className="grid-auto mt-8 pb-10">
          {/* Media Column */}
          <div className="col-span-12 md:col-span-6 grid-auto">
            <div className="col-span-12 md:col-start-2 md:col-end-7">
              <RouteFlipped flipId={props.event?.id}>
                <ResponsiveImage {...props.event?.hero?.image!} />
              </RouteFlipped>
            </div>
          </div>

          {/* Content Column */}
          <div className="col-span-12 md:col-span-5 grid-auto pt-5 md:pt-0">
            <div data-transition="children/fade" className="col-span-12 md:col-span-5">
              <div className="type-title-l-medium">{props.event?.title}</div>
              {dateRange && <div className="type-title-l-roman">{dateRange}</div>}
            </div>
            <div data-transition="children/fade" className="col-span-12 md:col-span-5 lg:col-span-4">
              <div className="h-2" />
              <ChipList chips={props.event?.chips} />
              <div className="h-3" />
              <ContentBlocks
                blocks={props.event?.contentBlocks!}
                wrapBlock={(child, ctx) => {
                  if (ctx.current.slug === "events/event-editor-details") {
                    return <EventRegistrationInfo data={props.event!} />
                  }
                  return <Fragment>{child}</Fragment>
                }}
              />
            </div>
          </div>
        </div>
      </StaggerTransitionRoot>
      <FloatingBackButton />
    </div>
  )
})
